<template>
    <div>
        <b-row>
            <b-col cols="2">
                <app-form-select-input
                    label="Año"
                    :options="years"
                    v-model="filters.year"
                ></app-form-select-input>
            </b-col>
            <b-col cols="2">
                <app-form-select-input
                    label="Periodo"
                    :options="months"
                    v-model="filters.period"
                ></app-form-select-input>
            </b-col>
            <b-col cols="2">
                <app-autocomplete
                    label="Cliente"
                    :items="clients"
                    v-model="filters.clientId"
                    :get-object="false"
                ></app-autocomplete>
            </b-col>
            <b-col cols="2">
                <app-form-select-input
                    label="Ejecutivo"
                    :options="executives"
                    v-model="filters.userId"
                ></app-form-select-input>
            </b-col>
            <b-col cols="2">
                <app-form-select-input
                    label="Pregunta de satisfaccion"
                    :options="satisfactionPollQuestions"
                    v-model="filters.satisfactionPollQuestionId"
                ></app-form-select-input>
            </b-col>
            <b-col cols="2" class="right-spaced d-flex align-items-end">
                <b-btn size="sm" variant="primary" @click="filter"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn size="sm" variant="secondary" @click="clear"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data: () => ({
        filters: {
            period: '',
            clientId: '',
            userId: '',
            satisfactionPollQuestionId: ''
        },
        satisfactionPollQuestions: []
    }),
    computed: {
        ...mapGetters(['clients', 'months', 'executives', 'years']),
    },
    methods: {
        filter() {
            this.$emit('filter', this.filters)
        },
        clear() {
            _.forIn(this.filters, (v, k) => (this.filters[k] = ''))
            this.$emit('filter', null)
        },
        async loadSatisfactionPollQuestion() {
            const { data } = await repo.get('satisfaction-polls/questions')
            this.satisfactionPollQuestions = data
        },
    },
    mounted() {
        this.load('clients')
        this.load('months')
        this.load('executives')
        this.load('validYears')
        this.loadSatisfactionPollQuestion()
    },
}
</script>
